import get from "lodash/get";
import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../modal";
import { notifyMobileApp } from "../../utils/biling-util";
import { useRillContext } from "../../rill/RillReact/share/base";
const {
  STRIPE: { PRICES },
} = require("../../constants");

function PlanSwitchConfirmationModal(props) {
  const { t } = useTranslation("coaching-portal");
  const { locals } = useRillContext();

  const { activeUser, momentTZ, query, invoice, activeUserToRequest } = locals;
  const { reactivate } = query;
  const planChange = get(query, "changed", false);
  const coupon = get(activeUserToRequest, "stripe.coupon");
  // The proration is the first line, the charge is the second line
  const invoiceData = invoice.invoice.lines.data;
  const subtotal = invoice.invoice.subtotal;
  const amountDue = invoice.invoice.amount_due;

  let planKey, price;
  switch (activeUserToRequest.stripe.plan) {
    case "launch_twelveMonth":
      planKey = "planTwelveMonth";
      price = PRICES.twelveMonths;
      break;
    case "launch_threeMonth":
      planKey = "planThreeMonth";
      price = PRICES.threeMonths;
      break;
    case "launch_oneMonth":
      planKey = "planMonthly";
      price = PRICES.oneMonth;
      break;
    case "v2_premium_monthly":
      planKey = "planPremiumMonthly";
      price = PRICES.v2_premium_monthly;
      break;
    case "v2_premium_annually":
      planKey = "planPremiumAnnual";
      price = PRICES.v2_premium_annually;
      break;
    case "v2_standard_monthly":
      planKey = "planStandardMonthly";
      price = PRICES.v2_standard_monthly;
      break;
    case "v2_standard_annually":
      planKey = "planStandardAnnual";
      price = PRICES.v2_standard_annually;
      break;
    default:
      planKey = null;
  }
  const plan = planKey ? t(`planSwitch.${planKey}`) : "";
  const isPremium =
    activeUserToRequest.stripe.plan === "v2_premium_annually" ||
    activeUserToRequest.stripe.plan === "v2_premium_monthly";

  // Calculate amount
  let prorationAmount = 0;
  if (
    Math.abs(invoice.invoice.starting_balance) > invoice.invoice.subtotal ||
    invoice.invoice.amount_due == 0
  ) {
    // User has more credit in their account than the cost of switching plans
    prorationAmount = (price / 100).toFixed(2);
  } else {
    prorationAmount = Math.abs(invoiceData[0].amount / 100).toFixed(2);
  }

  const periodEnd = momentTZ(activeUserToRequest.stripe.period_end).format(
    "MMM. DD, YYYY"
  );
  const chargedAmount =
    amountDue > 0 ? (subtotal / 100).toFixed(2) : "0.00";
  return (
    <Modal width="600px">
      <div className="head">
        <h2 className="alt">
          {reactivate
            ? t("planSwitch.reactivationConfirmation")
            : t("planSwitch.planSwitchConfirmation")}
        </h2>
      </div>
      {reactivate && !planChange ? (
        <div className="body">
          <div className="columns">
            <div className="column" data-col="1/1">
              {isPremium && (
                <p>{t("planSwitch.thankYou", { name: activeUser.name })}</p>
              )}
              <p>
                {t("planSwitch.reactivatedMessage", { plan })}
              </p>
              <p>
                {t("planSwitch.membershipValidThrough", {
                  periodEnd,
                  amount: chargedAmount,
                })}
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="body">
          <div className="columns">
            <div className="column" data-col="1/1">
              {isPremium && (
                <p>{t("planSwitch.thankYou", { name: activeUser.name })}</p>
              )}
              <p>
                {t("planSwitch.planChangedMessage", {
                  plan,
                  prorationAmount,
                  amount: chargedAmount,
                  periodEnd,
                })}
              </p>
              <p>{t("planSwitch.renewAtEndOfCycle")}</p>
            </div>
          </div>
        </div>
      )}
      <div className="foot">
        <a
          className="button"
          onClick={() => notifyMobileApp()}
          href="/dashboard/settings/subscription"
        >
          {t("common:close")}
        </a>
      </div>
    </Modal>
  );
}

export default PlanSwitchConfirmationModal;
